import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';
import { customerSchema } from 'schemas/customers';
import { getEntities } from 'selectors/entities';
import * as coreSelectors from 'selectors/core';

export const getCustomerValueById = createSelector(
    [coreSelectors.getId, getEntities],
    (id, entities) => denormalize(id, customerSchema, entities)
  )